module.exports = __webpack_public_path__ + "static/media/td.97c1759b.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/td.svg
// module id = 951
// module chunks = 0